import React from 'react';
import { View as RNView, ViewStyle, StyleSheet } from 'react-native';

interface ViewProps {
    children: React.ReactNode;
    style?: ViewStyle;
    className?: string;
    variant?: 'pagecontainer' | 'section' | 'card' | 'header' | 'footer';
    padding?: 'none' | 'small' | 'medium' | 'large' | 'xlarge';
    paddingHorizontal?: 'none' | 'small' | 'medium' | 'large' | 'xlarge';
    paddingVertical?: 'none' | 'small' | 'medium' | 'large' | 'xlarge';
}

const paddingValues = {
    none: 0,
    small: 8,
    medium: 16,
    large: 24,
    xlarge: 32,
};

const variantStyles = StyleSheet.create({
    pagecontainer: {
        flex: 1,
        backgroundColor: '#fff',
        paddingHorizontal: 24,
    },
    section: {
        marginVertical: 12,
        backgroundColor: '#f9f9f9',
        borderRadius: 8,
    },
    card: {
        backgroundColor: '#fff',
        borderRadius: 12,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 4,
        elevation: 3,
    },
    header: {
        paddingTop: 16,
        paddingBottom: 8,
        borderBottomWidth: 1,
        borderBottomColor: '#e0e0e0',
    },
    footer: {
        paddingTop: 8,
        paddingBottom: 16,
        borderTopWidth: 1,
        borderTopColor: '#e0e0e0',
    },
});

export const View: React.FC<ViewProps> = ({
    children,
    style,
    className,
    variant,
    padding,
    paddingHorizontal,
    paddingVertical,
}) => {
    const paddingStyle: ViewStyle = {};

    if (padding) {
        paddingStyle.padding = paddingValues[padding];
    }

    if (paddingHorizontal) {
        paddingStyle.paddingHorizontal = paddingValues[paddingHorizontal];
    }

    if (paddingVertical) {
        paddingStyle.paddingVertical = paddingValues[paddingVertical];
    }

    const combinedStyle = [
        variant && variantStyles[variant],
        paddingStyle,
        style,
    ];

    return (
        <RNView style={combinedStyle} testID={className}>
            {children}
        </RNView>
    );
};